

































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { ISegmentTypes } from "@/data/enums/segments";
import { ISegment } from "@/models/segments";
import { mapState } from "vuex";
import { IState } from "@/store";
import { ActionTypes } from "@/data/enums";
import _ from "@/boot/lodash";

@Component({
  computed: {
    ...mapState({
      segments(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.SEGMENTS,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class SegmentsAutocomplete extends Mixins(
  RequestPromises,
  Context
) {
  // Props
  @Prop({
    default: null,
    type: String,
    validator: val => _.values(ISegmentTypes).includes(val)
  })
  public segmentType;

  @Prop({ required: true })
  public value;

  @Prop({ default: false })
  public likeMatch!: boolean;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public rules!: boolean;

  @Prop({ default: null })
  public dataScope!: string;

  public isLoading = false;

  // Data
  public filterText = "";
  public segments!: ISegment[];

  // Lifecycle methods
  public created() {
    this.$store.dispatch(`data/${DataModules.SEGMENTS}/list`, {
      vm: this,
      scope: this.dataScope,
      params: {
        limit: 0,
        ...this.filterForSegmentType
      }
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.SEGMENTS,
      scope: this.dataScope,
      vm: this
    });
  }

  // Getters
  public get canAddSegment() {
    return this.$userCan("create_segment");
  }

  public get filterForSegmentType() {
    if (!this.segmentType) return {};
    if (this.likeMatch) return { "filter[type|like]": `${this.segmentType}%` };
    return { "filter[type]": this.segmentType };
  }

  public get filteredSegments() {
    return _.filter(this.segments, segment => {
      return _.includes(
        segment.name.toLowerCase(),
        this.filterText.toLowerCase()
      );
    });
  }

  // Methods
  public onSelect(selected) {
    this.$emit("input", _.get(selected, "id", 0));
    this.$emit("select", selected);
  }

  public addNewSegment() {
    if (!this.canAddSegment) {
      return;
    }
    this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import("@/components/app/admin/segments/addEditSegmentModal.vue"),
        props: {
          segmentType: this.segmentType,
          actionType: ActionTypes.CREATE
        },
        events: {
          "segment-created": segment => {
            this.onSelect(segment);
          }
        }
      }
    });
  }
}
